import { cn } from 'src/lib/utils'
import type { ButtonProps } from 'src/shared/components/ui/buttons/button'
import { Button } from 'src/shared/components/ui/buttons/button'

interface AuthSubmitButtonProps extends ButtonProps {
  isLoading?: boolean
  className?: string
}

export default function AuthSubmitButton({ isLoading = false, className, children, ...props }: AuthSubmitButtonProps) {
  return (
    <Button
      type="submit"
      size="lg"
      className={cn('h-[55px] w-full rounded-full bg-secondary text-[15px] xs:text-[16px]', className)}
      isLoading={isLoading}
      {...props}
    >
      {children}
    </Button>
  )
}
